import { render, staticRenderFns } from "./DashboardClientes.vue?vue&type=template&id=c13eb020"
import script from "./DashboardClientes.vue?vue&type=script&lang=js"
export * from "./DashboardClientes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports